import Vue from 'vue'

const getDeviceId = () => {
  try {
    if (!Vue.prototype.$amplitude) throw 'Amplitude is not set up'

    const instance = Vue.prototype.$amplitude.getInstance()
    const { deviceId } = instance.options

    return deviceId
  } catch (err) {
    console.error(err)

    return undefined
  }
}

export default getDeviceId
